import React from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { AnnouncementBar } from "./AnnouncementBar";
import { CTABlock } from "./CTABlock";
import { useQuery } from "@tanstack/react-query";
import { get } from "../../lib/api";
import { useReveal } from "../../lib/useReveal";

export function MarketingLayout({ children, cta = true }) {
  const { data: settings } = useQuery({ queryKey: ["site"], queryFn: () => get("/site") });
  const loc = useLocation();
  useReveal(loc.pathname);
  useReveal(children);
  React.useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:z-[60] focus:bg-ink-950 focus:text-white focus:px-4 focus:py-2">Skip to content</a>
      <AnnouncementBar announcement={settings?.announcement} />
      <Header />
      <main id="main" key={loc.pathname} className="page-enter">{children}</main>
      {cta && <CTABlock />}
      <Footer settings={settings} />
    </>
  );
}
